import Base from "./Base";

import { listJobLongList } from "api/graphql/queries.js";

import { updateJobLongList } from "./graphql/mutations.js";

export default class JobLongListAPI extends Base {
  listJobLongList(payload) {
    return this.apiClient.request({
      query: listJobLongList,
      payload,
    });
  }

  updateJobLongList(payload) {
    return this.apiClient.request({
      query: updateJobLongList,
      payload,
    });
  }
}
